// ─── Technology Product Families ───────────────────────────────────────────
//
// createEntityCrudClient is not used here: unlike every other entity in this
// file, `apiRequest<{ data: X }>` is called explicitly and `.data` is
// unwrapped a second time — `apiRequest` itself already unwraps the
// `{ data: T }` envelope, so this is a pre-existing double-wrap quirk kept
// as-is (issue #1406 preserves existing behavior exactly; fixing it would be
// an out-of-scope behavior change).

import { apiRequest } from './http';

export interface TechnologyProductFamily {
  entityId: string;
  entityType: 'TechnologyProductFamily';
  name: string;
  description?: string;
  tags?: string[];
}

export interface CreateTechnologyProductFamilyInput {
  name: string;
  description?: string;
  tags?: string[];
}

export interface UpdateTechnologyProductFamilyInput {
  name?: string;
  description?: string;
  tags?: string[];
}

export async function createTechnologyProductFamily(
  input: CreateTechnologyProductFamilyInput
): Promise<TechnologyProductFamily> {
  const result = await apiRequest<{ data: TechnologyProductFamily }>(
    '/technology-product-families',
    { method: 'POST', body: JSON.stringify(input) }
  );
  return result.data;
}

export async function updateTechnologyProductFamily(
  id: string,
  input: UpdateTechnologyProductFamilyInput
): Promise<TechnologyProductFamily> {
  const result = await apiRequest<{ data: TechnologyProductFamily }>(
    `/technology-product-families/${id}`,
    { method: 'PUT', body: JSON.stringify(input) }
  );
  return result.data;
}

export async function deleteTechnologyProductFamily(id: string): Promise<void> {
  return apiRequest<void>(`/technology-product-families/${id}`, { method: 'DELETE' });
}
